import { useFeatureFlagEnabled } from '@/lib/analytics';

/**
 * PostHog feature flag gating the offline-download feature (the
 * "Make available offline" button and the downloaded indicators).
 *
 * Create/toggle the `offline-download` flag in PostHog. While the flag value
 * is still loading, `useFeatureFlagEnabled` returns `undefined`, which we
 * coerce to `false` so the feature stays hidden until explicitly enabled.
 */
export const OFFLINE_FEATURE_FLAG = 'offline-download';

export function useOfflineEnabled(): boolean {
  return !!useFeatureFlagEnabled(OFFLINE_FEATURE_FLAG);
}
